export const createCanvas = (crop, scale) => {
    const canvas = document.createElement("canvas");
    canvas.width = crop.width * scale;
    canvas.height = crop.height * scale;
    const context = canvas.getContext("2d");
    if (!context)
        throw new Error(`Unable to create canvas context`);
    const drawImage = (image) => context.drawImage(image, crop.left, crop.top, crop.width, crop.height, 0, 0, crop.width * scale, crop.height * scale);
    return { canvas, context, drawImage };
};
